import { PapiGallection } from '@wix/da-papi-types';
import { getDenormalizedDataEntitiesByIds } from '../../redux/entities/selectors';

import { galleryFolderSchema } from '../../redux/normalizr/schemas/folder';

import { reduxKey } from './constants';

export const getIsReduxModuleReady = (state): boolean => state?.[reduxKey]?.reduxReady;

export const getGallectionIds = (state, groupid, type): number[] | undefined =>
  state?.[reduxKey]?.gallections?.[groupid]?.[type];

export const getGallections = (state, groupid, type): PapiGallection[] | undefined => {
  const gallectionIds = getGallectionIds(state, groupid, type);
  return (
    gallectionIds && getDenormalizedDataEntitiesByIds(state, galleryFolderSchema, gallectionIds)
  );
};
